import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import useAxiosInterceptors from '../axios/useAxios';
import { getLocalStorageItem } from '../utils/localStorage/getLocalStorageItem';

export const NavigationTracker = () => {
  const location = useLocation();
  const axiosInstance = useAxiosInterceptors();
  const user = useSelector((state) => state.user);
  const previousLocation = useRef(null);

  useEffect(() => {
    const cart = getLocalStorageItem('cartItems');

    const orderId = cart?._id || null;
    
    const currentPath = location.pathname;
    const fullUrl = window.location.href;
    
    let navigationType = 'navigate';

    const navEntry = window.performance?.getEntriesByType?.('navigation')?.[0];
    if (navEntry) {
      navigationType = navEntry.type;
    } else if(window.performance?.navigation) {
      const type = window.performance.navigation.type;
      if(type === 1) {
        navigationType = 'reload';
      } else if(type === 2) {
        navigationType = 'back_forward';
      }
    }

    const navigationData = {
      path: currentPath,
      fullUrl,
      previousPath: previousLocation.current?.pathname || null,
      navigationType,
      isFirstNavigation: !previousLocation.current,
    };

    try {
    axiosInstance.post('/user/logger/navigation', {
        orderId,
        navigationData
    });
    } catch (error) {
    console.error('Navigation logging failed:', error);
    }

    previousLocation.current = location;

  }, [location, user?._id, axiosInstance]);

  return null;
};